import { PageSizeSelector } from "./PageSizeSelector";
import { SessionsFilter } from "./SessionsFilter";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import type { PageSizeOption } from "@/hooks/dashboard/usePageSize";
import type { StatusFilter } from "@/hooks/dashboard/useSessionFilters";

interface SessionsHeaderProps {
  statusFilter: StatusFilter;
  onStatusChange: (status: StatusFilter) => void;
  pageSize: PageSizeOption;
  onPageSizeChange: (newSize: PageSizeOption) => void;
  onRefresh: () => void;
}

export function SessionsHeader({
  statusFilter,
  onStatusChange,
  pageSize,
  onPageSizeChange,
  onRefresh,
}: SessionsHeaderProps) {
  return (
    <div className="flex gap-4 items-center">
      <SessionsFilter
        statusFilter={statusFilter}
        onStatusChange={onStatusChange}
      />
      <PageSizeSelector
        pageSize={pageSize}
        onPageSizeChange={onPageSizeChange}
      />
      <Button
        variant="outline"
        size="sm"
        onClick={onRefresh}
        title="Refresh sessions"
      >
        <RefreshCw className="h-4 w-4" />
      </Button>
    </div>
  );
}